<template>
  <div id="app-div" class="subjectManuscript" style="overflow-y: hidden">
    <div class="top">
      <div style="background-color: #f3f3f3; height: 40px; line-height: 40px">
        <div style="float: left">
          <span style="margin-left: 10px; font-size: 15px">
            <img src="../../../assets/u3220.png" />
            课题稿件统计
          </span>
        </div>
        <div style="clear: both"></div>
        <div style="margin: 8px">
          <label style="margin-left: 15px">提交签发日期：</label>
          <a-date-picker :value="leftDate" @change="leftDateChange" />
          <label style="padding: 15px">至</label>
          <a-date-picker :value="rightDate" @change="rightDateChange" />
          <a-checkbox-group
            :options="statusList"
            v-model="selectedStatus"
            style="margin-left: 50px"
          />
          <a-button type="primary" class="query_btn" @click="query"
            >查询</a-button
          >
        </div>
      </div>
    </div>
    <div class="bottom" id="bottom" style="margin-top: 60px">
      <template>
        <div
          style="
            width: 100%;
            height: 200px;
            border: 1px solid #d7d7d7;
            margin-top: 35px;
          "
        >
          <div class="edit-top" style="margin-top: 19px">
            <div class="box" style="margin-left: 150px">
              <p>已录用课题类稿件</p>
              <span>{{ data.employCountKt }}</span>
            </div>
            <div class="box" style="margin-left: 50px; margin-right: 50px">
              <p>总录用稿件</p>
              <span>{{ data.employCount }}</span>
            </div>
            <div class="box" style="margin-right: 150px">
              <p>课题稿件占比</p>
              <span>{{ data.employRate }}%</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
export default {
  name: 'subjectManuscript',
  data() {
    return {
      data: {},
      leftDate: null,
      rightDate: null,
      beginTime: '',
      finishTime: '',
      statusList: [{ label: '包含总编未签发刊次', value: '11' }],
      selectedStatus: ['8', '9', '10', '11', '91']
    };
  },
  computed: {},
  methods: {
    query() {
      this.axios
        .get('/statistical/subjectManuscript', {
          params: {
            beginTime: this.beginTime,
            finishTime: this.finishTime,
            statusList: this.selectedStatus.join(','),
            sortField: 'code',
            sortType: 'desc',
            page: 1,
            limit: 100000,
            time: new Date().getTime()
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: 'repeat' });
          }
        })
        .then((res) => {
          if (res.data != null) {
            this.data = res.data;
          } else {
            this.utils.messageInfo(this, 'error', '查询课题稿件统计失败！');
          }
        });
    },
    leftDateChange(date, dateString) {
      this.beginTime = dateString;
      this.leftDate = date;
    },
    rightDateChange(date, dateString) {
      this.finishTime = dateString;
      this.rightDate = date;
    }
  },
  created() {
    const year = new Date().getFullYear();
    //第一天
    const queryDate = year + '-01-01';
    this.beginTime = queryDate;
    this.query();
  },
  mounted() {}
};
</script>

<style>
@import '../../../assets/css/Tongji.css';
</style>
<style>
#bottom
  .ant-table-wrapper
  .ant-spin-nested-loading
  .ant-spin-container
  .ant-table
  .ant-table-content
  .ant-table-scroll
  .ant-table-header {
  width: 100%;
  overflow: auto !important;
  padding-right: 17px;
  height: 64px;
  box-sizing: border-box;
  border: none;
}
</style>

